// import React, { useState, useEffect } from 'react';
// import { toast } from 'react-toastify';
// import moment from 'moment';
// import { MdRefresh } from 'react-icons/md';
// import { summaryApi } from 'common';

// const UserRepairRequests = () => {
//     const [requests, setRequests] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [selectedImages, setSelectedImages] = useState([]);
//     const [showImageModal, setShowImageModal] = useState(false);

//     // Fetch user's repair requests
//     const fetchUserRequests = async () => {
//         try {
//             setLoading(true);
//             const response = await fetch(summaryApi.getUserRepairRequests.url, {
//                 method: summaryApi.getUserRepairRequests.method,
//                 credentials: 'include',
//                 headers: {
//                     'Content-Type': 'application/json'
//                 }
//             });

//             const data = await response.json();

//             if (data.success) {
//                 setRequests(data.data);
//             } else {
//                 toast.error(data.message || 'Failed to fetch requests');
//             }
//         } catch (error) {
//             console.error('Error fetching requests:', error);
//             toast.error('Failed to fetch repair requests');
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchUserRequests();
//     }, []);

//     // View images in modal
//     const viewImages = (images) => {
//         setSelectedImages(images);
//         setShowImageModal(true);
//     };

//     // Get status badge color
//     const getStatusColor = (status) => {
//         switch (status) {
//             case 'pending':
//                 return 'bg-yellow-100 text-yellow-800 border-yellow-300';
//             case 'in-progress':
//                 return 'bg-blue-100 text-blue-800 border-blue-300';
//             case 'completed':
//                 return 'bg-green-100 text-green-800 border-green-300';
//             case 'rejected':
//                 return 'bg-red-100 text-red-800 border-red-300';
//             default:
//                 return 'bg-gray-100 text-gray-800 border-gray-300';
//         }
//     };

//     // Get status icon
//     const getStatusIcon = (status) => {
//         switch (status) {
//             case 'pending':
//                 return '⏳';
//             case 'in-progress':
//                 return '🔧';
//             case 'completed':
//                 return '✅';
//             case 'rejected':
//                 return '❌';
//             default:
//                 return '📋';
//         }
//     };

//     if (loading) {
//         return (
//             <div className="flex justify-center items-center h-64">
//                 <div className="text-xl text-gray-600">Loading your requests...</div>
//             </div>
//         );
//     }

//     return (
//         <div className="max-w-5xl mx-auto p-6">
//             <div className="flex justify-between items-center mb-6">
//                 <div>
//                     <h1 className="text-3xl font-bold text-gray-800">My Repair Requests</h1>
//                     <p className="text-gray-600 mt-1">Track all your device repair requests</p>
//                 </div>
//                 <button
//                     onClick={fetchUserRequests}
//                     className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
//                 >
//                     <MdRefresh size={20} />
//                     Refresh
//                 </button>
//             </div>

//             {requests.length === 0 ? (
//                 <div className="text-center py-16 bg-gray-50 rounded-lg">
//                     <div className="text-6xl mb-4">📱</div>
//                     <p className="text-gray-600 text-lg mb-4">No repair requests found</p>
//                     <p className="text-gray-500">Submit your first repair request to get started</p>
//                 </div>
//             ) : (
//                 <div className="space-y-6">
//                     {requests.map((request) => (
//                         <div key={request._id} className="bg-white rounded-lg shadow-md border border-gray-200 overflow-hidden">
//                             {/* Header */}
//                             <div className="bg-gradient-to-r from-blue-500 to-blue-600 p-6 text-white">
//                                 <div className="flex justify-between items-start">
//                                     <div>
//                                         <h3 className="text-2xl font-bold mb-1">
//                                             {request.deviceBrand} {request.deviceModel}
//                                         </h3>
//                                         <p className="text-blue-100">
//                                             {request.deviceType} • Submitted {moment(request.createdAt).fromNow()}
//                                         </p>
//                                     </div>
//                                     <span className={`px-4 py-2 rounded-full text-sm font-semibold border-2 ${getStatusColor(request.status)}`}>
//                                         {getStatusIcon(request.status)} {request.status.toUpperCase()}
//                                     </span>
//                                 </div>
//                             </div>

//                             {/* Body */}
//                             <div className="p-6">
//                                 {/* Issue Description */}
//                                 <div className="mb-6">
//                                     <h4 className="font-semibold text-gray-800 mb-2 flex items-center gap-2">
//                                         <span>🔍</span> Issue Description
//                                     </h4>
//                                     <p className="text-gray-700 bg-gray-50 p-4 rounded-lg">{request.issueDescription}</p>
//                                 </div>

//                                 {/* Images */}
//                                 {request.images && request.images.length > 0 && (
//                                     <div className="mb-6">
//                                         <h4 className="font-semibold text-gray-800 mb-3 flex items-center gap-2">
//                                             <span>📸</span> Device Images ({request.images.length})
//                                         </h4>
//                                         <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
//                                             {request.images.map((image, index) => (
//                                                 <img
//                                                     key={index}
//                                                     src={image}
//                                                     alt={`Device ${index + 1}`}
//                                                     className="w-full h-32 object-cover rounded-lg border-2 border-gray-300 cursor-pointer hover:opacity-75 transition"
//                                                     onClick={() => viewImages(request.images)}
//                                                 />
//                                             ))}
//                                         </div>
//                                     </div>
//                                 )}

//                                 {/* Contact Info */}
//                                 <div className="mb-6 bg-gray-50 p-4 rounded-lg">
//                                     <h4 className="font-semibold text-gray-800 mb-2 flex items-center gap-2">
//                                         <span>📞</span> Contact Information
//                                     </h4>
//                                     <div className="grid grid-cols-1 md:grid-cols-2 gap-2 text-sm">
//                                         <p className="text-gray-700">
//                                             <span className="font-medium">Phone:</span> {request.contactPhone}
//                                         </p>
//                                         <p className="text-gray-700">
//                                             <span className="font-medium">Email:</span> {request.contactEmail}
//                                         </p>
//                                     </div>
//                                 </div>

//                                 {/* Admin Reply */}
//                                 {request.adminReply?.message ? (
//                                     <div className="bg-green-50 border-2 border-green-200 p-5 rounded-lg">
//                                         <h4 className="font-semibold text-green-800 mb-3 flex items-center gap-2 text-lg">
//                                             <span>💬</span> Admin Response
//                                         </h4>
//                                         <p className="text-gray-800 mb-3 leading-relaxed">{request.adminReply.message}</p>
//                                         <div className="flex items-center gap-2 text-sm text-gray-600">
//                                             <span className="font-medium">
//                                                 {request.adminReply.repliedBy?.firstName} {request.adminReply.repliedBy?.lastName}
//                                             </span>
//                                             <span>•</span>
//                                             <span>{moment(request.adminReply.repliedAt).format('MMM DD, YYYY [at] h:mm A')}</span>
//                                         </div>
//                                     </div>
//                                 ) : (
//                                     <div className="bg-yellow-50 border-2 border-yellow-200 p-4 rounded-lg text-center">
//                                         <p className="text-yellow-800 font-medium">
//                                             ⏳ Waiting for admin response...
//                                         </p>
//                                         <p className="text-yellow-700 text-sm mt-1">
//                                             We'll notify you once we review your request
//                                         </p>
//                                     </div>
//                                 )}
//                             </div>

//                             {/* Footer */}
//                             <div className="bg-gray-50 px-6 py-3 border-t border-gray-200">
//                                 <p className="text-sm text-gray-600">
//                                     Request ID: <span className="font-mono font-semibold">{request._id}</span>
//                                 </p>
//                             </div>
//                         </div>
//                     ))}
//                 </div>
//             )}

//             {/* Image Modal */}
//             {showImageModal && (
//                 <div 
//                     className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-50 p-4"
//                     onClick={() => setShowImageModal(false)}
//                 >
//                     <div className="relative max-w-4xl w-full" onClick={(e) => e.stopPropagation()}>
//                         <button
//                             onClick={() => setShowImageModal(false)}
//                             className="absolute -top-10 right-0 text-white text-3xl hover:text-gray-300"
//                         >
//                             ✕
//                         </button>
//                         <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                             {selectedImages.map((image, index) => (
//                                 <img
//                                     key={index}
//                                     src={image}
//                                     alt={`Device ${index + 1}`}
//                                     className="w-full h-auto rounded-lg"
//                                 />
//                             ))}
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default UserRepairRequests;



import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import moment from 'moment';
import { MdRefresh } from 'react-icons/md';
import { useTheme } from "../../components/Theme/ThemeProvider";
import { summaryApi } from 'common';
import { authFetch } from '../../helpers/authFetch';

const UserRepairRequests = () => {
    const [requests, setRequests] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedImages, setSelectedImages] = useState([]);
    const [showImageModal, setShowImageModal] = useState(false);
    const { colors } = useTheme();

    // Fetch user's repair requests
    const fetchUserRequests = async () => {
        try {
            setLoading(true);
            const response = await authFetch(summaryApi.getUserRepairRequests.url, {
                method: summaryApi.getUserRepairRequests.method,
                
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            const data = await response.json();

            if (data.success) {
                setRequests(data.data);
            } else {
                toast.error(data.message || 'Failed to fetch requests');
            }
        } catch (error) {
            console.error('Error fetching requests:', error);
            toast.error('Failed to fetch repair requests');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchUserRequests();
    }, []);

    // View images in modal
    const viewImages = (images) => {
        setSelectedImages(images);
        setShowImageModal(true);
    };

    // Get status badge color
    const getStatusColor = (status) => {
        switch (status) {
            case 'pending':
                return { bg: `${colors.warning}20`, text: colors.warning, border: colors.warning };
            case 'in-progress':
                return { bg: `${colors.primary}20`, text: colors.primary, border: colors.primary };
            case 'completed':
                return { bg: `${colors.success}20`, text: colors.success, border: colors.success };
            case 'rejected':
                return { bg: `${colors.error}20`, text: colors.error, border: colors.error };
            default:
                return { bg: `${colors.textSecondary}20`, text: colors.textSecondary, border: colors.textSecondary };
        }
    };

    // Get status icon
    const getStatusIcon = (status) => {
        switch (status) {
            case 'pending':
                return '⏳';
            case 'in-progress':
                return '🔧';
            case 'completed':
                return '✅';
            case 'rejected':
                return '❌';
            default:
                return '📋';
        }
    };

    if (loading) {
        return (
            <div className="flex justify-center items-center h-64">
                <div className="text-xl" style={{ color: colors.textSecondary }}>Loading your requests...</div>
            </div>
        );
    }

    return (
        <div className="max-w-5xl mx-auto p-6" style={{ backgroundColor: colors.bgPrimary, minHeight: '100vh' }}>
            <div className="flex justify-between items-center mb-6 mt-8">
                <div>
                    <h1 className="text-3xl font-bold" style={{ color: colors.text }}>
                        My Repair Requests
                    </h1>
                    <p className="mt-1" style={{ color: colors.textSecondary }}>
                        Track all your device repair requests
                    </p>
                </div>
                <button
                    onClick={fetchUserRequests}
                    className="flex items-center gap-2 px-4 py-2 rounded-lg transition"
                    style={{
                        backgroundColor: colors.primary,
                        color: '#ffffff'
                    }}
                >
                    <MdRefresh size={20} />
                    Refresh
                </button>
            </div>

            {requests.length === 0 ? (
                <div className="text-center py-16 rounded-lg" style={{ backgroundColor: colors.bgSecondary }}>
                    <div className="text-6xl mb-4">📱</div>
                    <p className="text-lg mb-4" style={{ color: colors.textSecondary }}>No repair requests found</p>
                    <p style={{ color: colors.textSecondary }}>Submit your first repair request to get started</p>
                </div>
            ) : (
                <div className="space-y-6">
                    {requests.map((request) => (
                        <div 
                            key={request._id} 
                            className="rounded-lg shadow-md overflow-hidden"
                            style={{ 
                                backgroundColor: colors.bgSecondary,
                                border: `1px solid ${colors.border}`
                            }}
                        >
                            {/* Header */}
                            <div 
                                className="p-6"
                                style={{
                                    background: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.accent} 100%)`,
                                    color: '#ffffff'
                                }}
                            >
                                <div className="flex justify-between items-start">
                                    <div>
                                        <h3 className="text-2xl font-bold mb-1">
                                            {request.deviceBrand} {request.deviceModel}
                                        </h3>
                                        <p style={{ color: 'rgba(255,255,255,0.9)' }}>
                                            {request.deviceType} • Submitted {moment(request.createdAt).fromNow()}
                                        </p>
                                    </div>
                                    <span 
                                        className="px-4 py-2 rounded-full text-sm font-semibold"
                                        style={{
                                            backgroundColor: getStatusColor(request.status).bg,
                                            color: getStatusColor(request.status).text,
                                            border: `2px solid ${getStatusColor(request.status).border}`
                                        }}
                                    >
                                        {getStatusIcon(request.status)} {request.status.toUpperCase()}
                                    </span>
                                </div>
                            </div>

                            {/* Body */}
                            <div className="p-6">
                                {/* Issue Description */}
                                <div className="mb-6">
                                    <h4 className="font-semibold mb-2 flex items-center gap-2" style={{ color: colors.text }}>
                                        <span>🔍</span> Issue Description
                                    </h4>
                                    <p 
                                        className="p-4 rounded-lg"
                                        style={{ 
                                            color: colors.text,
                                            backgroundColor: colors.bgTertiary
                                        }}
                                    >
                                        {request.issueDescription}
                                    </p>
                                </div>

                                {/* Images */}
                                {request.images && request.images.length > 0 && (
                                    <div className="mb-6">
                                        <h4 className="font-semibold mb-3 flex items-center gap-2" style={{ color: colors.text }}>
                                            <span>📸</span> Device Images ({request.images.length})
                                        </h4>
                                        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                                            {request.images.map((image, index) => (
                                                <img
                                                    key={index}
                                                    src={image}
                                                    alt={`Device ${index + 1}`}
                                                    className="w-full h-32 object-cover rounded-lg cursor-pointer hover:opacity-75 transition"
                                                    style={{ border: `2px solid ${colors.border}` }}
                                                    onClick={() => viewImages(request.images)}
                                                />
                                            ))}
                                        </div>
                                    </div>
                                )}

                                {/* Contact Info */}
                                <div className="mb-6 p-4 rounded-lg" style={{ backgroundColor: colors.bgTertiary }}>
                                    <h4 className="font-semibold mb-2 flex items-center gap-2" style={{ color: colors.text }}>
                                        <span>📞</span> Contact Information
                                    </h4>
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-2 text-sm">
                                        <p style={{ color: colors.textSecondary }}>
                                            <span className="font-medium">Phone:</span> {request.contactPhone}
                                        </p>
                                        <p style={{ color: colors.textSecondary }}>
                                            <span className="font-medium">Email:</span> {request.contactEmail}
                                        </p>
                                    </div>
                                </div>

                                {/* Admin Reply */}
                                {request.adminReply?.message ? (
                                    <div 
                                        className="p-5 rounded-lg"
                                        style={{
                                            backgroundColor: `${colors.success}15`,
                                            border: `2px solid ${colors.success}40`
                                        }}
                                    >
                                        <h4 className="font-semibold mb-3 flex items-center gap-2 text-lg" style={{ color: colors.success }}>
                                            <span>💬</span> Admin Response
                                        </h4>
                                        <p className="mb-3 leading-relaxed" style={{ color: colors.text }}>
                                            {request.adminReply.message}
                                        </p>
                                        <div className="flex items-center gap-2 text-sm" style={{ color: colors.textSecondary }}>
                                            <span className="font-medium">
                                                {request.adminReply.repliedBy?.firstName} {request.adminReply.repliedBy?.lastName}
                                            </span>
                                            <span>•</span>
                                            <span>{moment(request.adminReply.repliedAt).format('MMM DD, YYYY [at] h:mm A')}</span>
                                        </div>
                                    </div>
                                ) : (
                                    <div 
                                        className="p-4 rounded-lg text-center"
                                        style={{
                                            backgroundColor: `${colors.warning}15`,
                                            border: `2px solid ${colors.warning}40`
                                        }}
                                    >
                                        <p className="font-medium" style={{ color: colors.warning }}>
                                            ⏳ Waiting for admin response...
                                        </p>
                                        <p className="text-sm mt-1" style={{ color: colors.textSecondary }}>
                                            We'll notify you once we review your request
                                        </p>
                                    </div>
                                )}
                            </div>

                            {/* Footer */}
                            <div 
                                className="px-6 py-3"
                                style={{ 
                                    backgroundColor: colors.bgTertiary,
                                    borderTop: `1px solid ${colors.border}`
                                }}
                            >
                                <p className="text-sm" style={{ color: colors.textSecondary }}>
                                    Request ID: <span className="font-mono font-semibold">{request._id}</span>
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            )}

            {/* Image Modal */}
            {showImageModal && (
                <div 
                    className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-50 p-4"
                    onClick={() => setShowImageModal(false)}
                >
                    <div className="relative max-w-4xl w-full" onClick={(e) => e.stopPropagation()}>
                        <button
                            onClick={() => setShowImageModal(false)}
                            className="absolute -top-10 right-0 text-white text-3xl hover:text-gray-300"
                        >
                            ✕
                        </button>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            {selectedImages.map((image, index) => (
                                <img
                                    key={index}
                                    src={image}
                                    alt={`Device ${index + 1}`}
                                    className="w-full h-auto rounded-lg"
                                />
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default UserRepairRequests;